---
title: Book recommendations
description: A collection of books that have shaped my thinking, work, and perspective over the years.
---

**"What books would you recommend?"** is _the_ most common question I get asked by new designers. TBH I became tired of answering, so I made this list to share instead. I planned on adding some thoughts around each book, but on here I'm a cobbler and these are my shoes, so... hopefully the raw list is still a good starting point for someone. 

In no order:

- [Just Enough Research](https://www.goodreads.com/book/show/17236175-just-enough-research) by Erika Hall
- [The Design of Everyday Things](https://www.goodreads.com/book/show/840.The_Design_of_Everyday_Things) by Don Norman
- [The Elements of Style](https://www.goodreads.com/book/show/33514.The_Elements_of_Style) by Strunk & White
- [Mismatch](https://www.goodreads.com/book/show/39644200-mismatch) by Kat Holmes
- [Continuous Discovery Habits](https://www.goodreads.com/book/show/58046715-continuous-discovery-habits) by Teresa Torres
- [Inspired](https://www.goodreads.com/book/show/35249663-inspired) by Marty Cagan
- [Don't Make Me Think](https://www.goodreads.com/book/show/18197267-don-t-make-me-think-revisited) by Steve Krug
- [Sprint](https://www.goodreads.com/book/show/25814544-sprint) by Jake Knapp
- [9 Lies About Work](https://www.goodreads.com/book/show/40086702-nine-lies-about-work) by Marcus Buckingham & Ashley Goodall

Bonus: 
- [A Pattern Language](https://www.goodreads.com/book/show/79766.A_Pattern_Language) by Christopher Alexander 


